import React, { Component } from "react";
import "./styles/customDatePickerInput.css";

class CustomDatePickerButton extends Component {
  render() {
    const { onClick, value } = this.props;
    return (
      <button
        type="button"
        className={"btn btn-outline-secondary bg-white-mouseOff"}
        onClick={onClick}
      >
        {value || "(Select Date...)"}
      </button>
    );
  }
}

export default CustomDatePickerButton;
